/**
 * Story 115 - the single "not applicable" literal of the Request form.
 *
 * The in-scope dropdowns start empty, as they did before this story, and offer N/A as one more
 * option at the end of their list. Picking it writes the literal like any other answer, so
 * "it does not apply" stays distinguishable from "not answered" (dilemma D7).
 *
 * Text fields are never given a value. The N/A on paper is printed by Sun, which prints it in
 * every report cell whose value arrives empty.
 */

export const NA = 'N/A'

// The old literal, still alive in saved parts (PartReference.extendedColumn8, perteneceCUF). It
// coexists with N/A without a migration; it lives here so tests can name it without repeating
// the string.
export const LEGACY_NA = 'NA'
